var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"export-data-options":_vm.exportDataOptions,"show-page":false,"defaultSearchKey":_vm.defaultSearchKey,"placeholder":_vm.$t('system.common_log_filter_tip')}})
}
var staticRenderFns = []

export { render, staticRenderFns }